module.exports = __webpack_public_path__ + "static/vmware_16.e2d16bd2.jpg";